import { render, staticRenderFns } from "./OrdersHistoryDetail.vue?vue&type=template&id=7f34eff2&scoped=true&"
import script from "./OrdersHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./OrdersHistoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrdersHistoryDetail.vue?vue&type=style&index=0&id=7f34eff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f34eff2",
  null
  
)

export default component.exports